import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import PromotonListLayer from "../components/PromotinListLayer";
 
 
const HighlightListPage = () => {
  return (
    <>

 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Promotions  </h5><Breadcrumb title="Promotions" /></div>
 
        <PromotonListLayer />
 
 
 
    </>
  );
};
 
export default HighlightListPage;
 
 